import { render, staticRenderFns } from "./SimilarListingsAveragePrice.vue?vue&type=template&id=12fd4798&"
import script from "./SimilarListingsAveragePrice.vue?vue&type=script&lang=js&"
export * from "./SimilarListingsAveragePrice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports